export default __webpack_public_path__ + "static/media/shirt-front.84ead4b1.png";